export default "__VITE_ASSET__C41Jrg9K__"